import { Button } from 'react-bootstrap';
import { Link } from 'react-router';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faBuoyMooring } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { HOMEPAGE } from '@constants/routes';
import ContentContainer from '@layouts/container/ContentContainer';
import PageContainer from '@layouts/container/PageContainer';

const Error = () => {
  return (
    <PageContainer>
      <ContentContainer
        containerClass='page-content d-flex flex-column flex-grow-1'
        contentClass='bg-body flex-grow-1 p-3 d-flex flex-column gap-4 justify-content-center align-items-center'
      >
        <FontAwesomeIcon icon={faBuoyMooring as IconDefinition} fontSize={64} className='text-primary' />
        <h3 className='mb-0 text-center'>Sorry we can&apos;t find that page.</h3>
        <p className='text-center'>It appears the page you are looking for does not exist.</p>
        <Button as={Link as any} to={HOMEPAGE} className='rounded-pill px-3'>
          Back to home
        </Button>
      </ContentContainer>
    </PageContainer>
  );
};

export default Error;
